"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterCompletePage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="auth-container">
    <div class="auth-card">
        <div class="auth-header">
            <div class="logo-section">
                <img src="/assets/logo.png" alt="IntHub" class="logo">
                <h1 class="app-title">${'app.name'.t()}</h1>
            </div>
        </div>

        <div class="auth-content">
            <div class="success-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 11l3 3l8-8"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9s4.03-9 9-9c1.51 0 2.93.37 4.18 1.03"></path>
                </svg>
            </div>
            
            <h2 class="success-title">${'register.complete.title'.t()}</h2>
            
            <div class="success-message">
                <p>${'register.complete.description'.t()}</p>
                ${x => x.email ? (0, fast_element_1.html) `<p class="email-info">${'register.complete.email.sent'.t()}: <strong>${x => x.email}</strong></p>` : ''}
            </div>

            <div class="action-buttons">
                <button type="button" class="btn btn-primary" @click="${x => x.goToLogin()}">
                    ${'register.complete.button.login'.t()}
                </button>
                
                <button type="button" class="btn btn-secondary" @click="${x => x.resendActivation()}">
                    ${'register.complete.button.resend'.t()}
                </button>
            </div>

            <div class="help-text">
                <p>${'register.complete.help.check_spam'.t()}</p>
                <p>${'register.complete.help.contact_support'.t()}</p>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  padding: 20px;
}

.auth-container {
  width: 100%;
  max-width: 500px;
}

.auth-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.auth-header {
  text-align: center;
  padding: 40px 40px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.logo {
  width: 64px;
  height: 64px;
  border-radius: 12px;
}

.app-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.auth-content {
  padding: 40px;
  text-align: center;
}

.success-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.success-icon svg {
  color: var(--success-color);
  width: 64px;
  height: 64px;
}

.success-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 24px 0;
}

.success-message {
  margin-bottom: 32px;
}

.success-message p {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 0 12px 0;
}

.email-info {
  color: var(--text-primary);
  font-weight: 500;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
}

.btn {
  padding: 14px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background: var(--primary-color-dark);
  transform: translateY(-1px);
}

.btn-secondary {
  background: transparent;
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.btn-secondary:hover {
  background: var(--primary-color);
  color: white;
}

.help-text {
  border-top: 1px solid var(--border-color);
  padding-top: 20px;
}

.help-text p {
  color: var(--text-tertiary);
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0 0 8px 0;
}

@media (max-width: 768px) {
  :host {
    padding: 12px;
  }
  .auth-header,
  .auth-content {
    padding: 24px;
  }
  .success-title {
    font-size: 1.5rem;
  }
  .action-buttons {
    gap: 16px;
  }
}`;
const shadowOptions = { "mode": "open" };
let RegisterCompletePage = class RegisterCompletePage extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.email = '';
    }
    connectedCallback() {
        super.connectedCallback();
        // Get email from URL params or localStorage if passed
        const urlParams = new URLSearchParams(window.location.search);
        const emailParam = urlParams.get('email');
        if (emailParam) {
            this.email = decodeURIComponent(emailParam);
        }
    }
    goToLogin() {
        component_1.SiteMenu.goto.bind(this)('/login');
    }
    resendActivation() {
        // TODO: Implement resend activation email functionality
        this.notifyService.notify('register.complete.resend.success'.t(), 'info');
    }
};
exports.RegisterCompletePage = RegisterCompletePage;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], RegisterCompletePage.prototype, "email", void 0);
exports.RegisterCompletePage = RegisterCompletePage = __decorate([
    (0, client_1.RWSView)('page-register-complete', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RegisterCompletePage);
RegisterCompletePage.defineComponent();
